import { WobBase, IWobBaseConstParam } from '@/models/wob/WobBase'

export interface IWobGliderBaseConstParam extends IWobBaseConstParam {
  gliId: number
  misId: number
  yosId: number | null
  gliKey: string
  misIdx: number
  gliCycle: number
}

export class WobGliderBase extends WobBase {
  public gliId: number
  public misId: number
  public yosId: number | null
  public gliKey: string
  public misIdx: number
  public gliCycle: number

  constructor({ gliId, misId, yosId, gliKey, misIdx, gliCycle, ...args }: IWobGliderBaseConstParam) {
    super(args)
    this.gliId = gliId
    this.misId = misId
    this.yosId = yosId
    this.gliKey = gliKey
    this.misIdx = misIdx
    this.gliCycle = gliCycle
  }
}
